import noop from 'lodash/noop';
import styled from 'styled-components';

import { BuyBarMobileSearchLayout } from 'productTemplate/components/buyBar/BuyBarMobileSearchLayout';
import FactsWindow from 'productTemplate/components/windows/FactsWindow';
import { FeatureFlags } from 'featureFlags/constants';
import { getProductTemplateCarouselImages } from 'productTemplate/utils/getProductTemplateCarouselImages';
import { IGmcOffers } from 'shared/types/Offer';
import { ImageGalleryMobile } from 'productTemplate/components/imageGallery/ImageGalleryMobile';
import { LOCALES } from 'localization/constants/configEnums';
import { ProductInfo } from 'productTemplate/components/footer/ProductInfo';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useStoreSelector } from 'store/hooks/storeHooks';
import { WindowItemGrid } from 'shared/components/Window';

export const ProductTemplateMobileSearchLayout = ({
  isAvailabilityRestricted,
  offersData,
  locale,
}: {
  isAvailabilityRestricted: boolean;
  offersData: IGmcOffers;
  locale?: LOCALES;
}) => {
  const { productTemplate } = useStoreSelector((state) => state.pdp);
  const isIgnoreInternalShotEnabled = useFeatureFlag(
    FeatureFlags.TEMP_WEB_ENABLE_PDP_IGNORE_INTERNAL_SHOT,
  );
  const productTemplateImages = getProductTemplateCarouselImages({
    productTemplate,
    showRobots: true,
    tempWebEnablePdpIgnoreInternalShot: isIgnoreInternalShotEnabled,
  });

  return (
    <>
      <ImageGalleryMobile isCrawler itemList={productTemplateImages} />
      <ProductInfo />
      {!isAvailabilityRestricted && (
        <BuyBarMobileSearchLayout isCrawler priceData={offersData} locale={locale} />
      )}
      <ProductTemplateMobileSearchLayout.FactsWindow isCrawler onClose={noop} />
    </>
  );
};

ProductTemplateMobileSearchLayout.FactsWindow = styled(FactsWindow)`
  position: relative;
  width: 100%;

  ${FactsWindow.Wrapper} {
    max-height: fit-content;
  }

  ${WindowItemGrid.Items} {
    grid-template-columns: repeat(4, 56px);
  }
`;
